import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps as any, {
    load: {
        key: 'AIzaSyARfInOzBzrGrRppTtY_ki3FidqjZfjeks',
    },
})